import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { BadgeRoot, ComparisonText, FeeRowRoot, FeeValueLine } from '../NewPublicPaymentOptionsSectionStyles';

/* ----- Fee value row ----- */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeeRow = ({
  label,
  value,
  description,
  comparison
}) => /*#__PURE__*/_jsxs(FeeRowRoot, {
  children: [/*#__PURE__*/_jsx(Text, {
    typography: "body-100",
    color: "text-secondary-default",
    children: label
  }), /*#__PURE__*/_jsxs(FeeValueLine, {
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-400",
      as: "span",
      children: value
    }), /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-secondary-default",
      as: "span",
      children: description
    })]
  }), comparison !== undefined && /*#__PURE__*/_jsx(ComparisonText, {
    children: comparison
  })]
});

/* ----- Transaction fees section header ----- */

export const TransactionFeesSectionHeader = ({
  title
}) => /*#__PURE__*/_jsx(Flex, {
  alignItems: "center",
  gap: "200",
  children: /*#__PURE__*/_jsx(Text, {
    as: "strong",
    typography: "heading-200",
    children: title
  })
});

/* ----- Check item row (orange for HubSpot, grey for Stripe) ----- */

export const CheckItem = ({
  iconColor,
  children
}) => /*#__PURE__*/_jsxs(Flex, {
  alignItems: "start",
  gap: "200",
  children: [/*#__PURE__*/_jsx(View, {
    as: "span",
    flexShrink: 0,
    paddingBlockStart: "50",
    children: /*#__PURE__*/_jsx(SuccessIcon, {
      color: iconColor
    })
  }), /*#__PURE__*/_jsx(Text, {
    typography: "body-100",
    children: children
  })]
});

/* ----- Payment method badge (icon + label pill) ----- */

export const PaymentMethodBadge = ({
  icon,
  label
}) => /*#__PURE__*/_jsxs(BadgeRoot, {
  children: [icon, /*#__PURE__*/_jsx(Text, {
    typography: "detail-100",
    as: "span",
    children: label
  })]
});